import {
  Box,
  Button,
  Grid,
  InputLabel,
  Stack,
  Typography,
} from "@mui/material";
import useResponsive from "../../hooks/useResponsive";

import { labelSty, textareaSty } from "../UIElements/styles-input";
import { useTheme } from "@mui/material/styles";
import { SelectInputBgWhite } from "../UIElements/select-bgwhite";
import { FC, useState } from "react";
import { InfoBox } from "../designUi";
import { Dot, SubscriptionIconLarge } from "../UIElements/svgIcons";
const SubscriptionContent = () => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xs");
  const isSmall = useResponsive("down", "sm", "xl");

  const data = [
    {
      plan: "Elite Efficiency Plan",
      price: "$9.99/month",
      
      image: "/assets/icons/01.svg",
      option: ["Option 1", "Option 2", "Option 3", "Option 4"],
    },
    {
      plan: "Base Plan",
      price: "$19.99/month",
      
      image: "/assets/icons/02.svg",
      option: ["Option 1", "Option 2", "Option 3", "Option 4"],
    },
    {
      plan: "Standard luxury Plan",
      price: "$29.99/month",
      
      image: "/assets/icons/03.svg",
      option: ["Option 1", "Option 2", "Option 3", "Option 4"],
    },
  ];

  return (
    <Stack sx={{ padding: 2, marginTop: 70 }}>
      <Grid container>
        <Grid
          item
          xs={isSmall ? 12 : isMedium ? 6 : 4}
          sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
        >
          <InfoBox
            title={"Total Subscription"}
            value={1000}
            icon={<SubscriptionIconLarge />}
          />
        </Grid>
        <Grid
          item
          xs={isSmall ? 12 : isMedium ? 6 : 4}
          sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
        >
          <InfoBox
            title={"Total Subscribed"}
            value={1000}
            icon={<SubscriptionIconLarge />}
          />
        </Grid>{" "}
        <Grid
          item
          xs={isSmall ? 12 : isMedium ? 6 : 4}
          sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
        >
          <InfoBox
            title={"Subscription Revenue "}
            value={1000}
            icon={<SubscriptionIconLarge />}
          />
        </Grid>{" "}
      </Grid>
      <Box
        sx={{
          width: "100%",
          marginY: 4,
          marginX: 2,
        }}
      >
        <Typography
          variant="cation"
          sx={{
            color: "#000E2C",
            fontFamily: "Inter",
          }}
        >
          Subscription
        </Typography>
        <Box sx={{ my: 4, display: "flex", gap: 3, flexWrap: "wrap" }}>
          {data?.map((val, id) => (
            <Box
              sx={{
                backgroundColor: "rgb(255, 255, 255)",
                borderRadius: "35px",
                width: isMedium ? 200 : 260,
                padding: 4,
                margin: 2,
              }}
            >
              <Stack direction={'row'} justifyContent={'flex-end'}>
                <Dot />
              </Stack>
              <img
                src={val?.image}
                alt=""
                width={120}
                height={120}
                style={{}}
              />
              <Typography
                variant="h4"
                sx={{
                  fontFamily: "Poppins",
                  letterSpacing: "-0.02em",
                  color: "#1E1E1E",
                  my: 3,
                }}
              >
                {val?.plan}
              </Typography>
              <Box >
                {val?.option.map((opt, i) => (
                  <Stack
                    direction={"row"}
                    sx={{ gap: 2, alignItems: "center", my: 2, }}
                  >
                    <img
                      src="/assets/icons/check-circle.svg"
                      alt=""
                      width={20}
                      height={20}
                    />
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: "12px",
                        fontWeight: 500,
                        lineHeight: "18.09px",
                      }}
                    >
                      {opt}
                    </Typography>
                  </Stack>
                ))}
              </Box>

              <Typography
                variant="h4"
                sx={{
                  fontFamily: "Poppins",
                  letterSpacing: "-0.02em",
                  fontWeight: 500,
                  color: "#1E1E1E",
                  my: 2,
                  mt:4,
                }}
              >
                {val?.price}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Stack>
  );
};

export default SubscriptionContent;
